import { isObjEqual, genVTK } from './utils/assist'
import TabManager from './core/tab-manager'
import AliveTab from './components/alive-tab'

// 全局接口
const facade = {}

// 比keep-alive更好用的路由缓存插件
const install = function(Vue, options = {}) {
    var { router } = options

    if (!router) {
        throw new Error("必须提供router实例")
    }

    // wrap
    const replaceOrigin = router.replace
    let replaceFlag = false // 是否replace

    router.replace = (location, onComplete, onAbort) => {
        replaceFlag = true
        replaceOrigin.call(router, location, onComplete, onAbort)
    }

    // config
    Object.keys(TabManager.options).forEach(k => {
        if (options[k]) {
            TabManager.options[k] = options[k]
        }
    })

    // singleTon
    const tabManager = new TabManager({ Vue })
    const VTK = TabManager.options.VTK

    // 添加VTK
    router.beforeEach((to, from, next) => {
        if (!to.query[VTK]) {
            const query = { ...to.query }
            // go to the same route will be set the same key
            if (to.path === from.path &&
                isObjEqual({ ...to.query, [VTK]: null }, { ...from.query, [VTK]: null }, ) &&
                from.query[VTK]) {
                query[VTK] = from.query[VTK]
            } else {
                query[VTK] = genVTK()
            }

            // 替换原路由
            next({ name: to.name, params: to.params, query, replace: replaceFlag || !from.query[VTK]  })
        } else {
            next()
        }
    })

    // 判断页面是否已缓存
    router.beforeEach((to, from, next) => {
        var isCache = tabManager.isCache(to)

        to.meta.cached = !!isCache

        next()
    })

    // 记录tab
    router.afterEach((to, from) => {
        var key = tabManager.record(to, from, replaceFlag)

        replaceFlag = false

        if (key) {
            var tab = tabManager.getTab(key)
            tab.pv++

            // 注入$tab
            Object.defineProperty(to.meta, "$tab", {
                // 不可枚举，值可以更改
                writable: true,
                value: tab
            })
        }
    })

    // Vue
    Vue.component('AliveTab', AliveTab(tabManager))

    Vue.mixin({
        beforeCreate() {
            this.$tab = this.$route && this.$route.meta && this.$route.meta.$tab || void(0)
        },

        created() {
            // 实例对象是否被缓存了
            this.$isCache = this.$tab && this.$tab.cached
        },

        beforeDestroy() {
            if (this.$tab) {
                this.$tab = null
            }
        },
    })

    // facade
    Object.assign(facade, {
        getRouteKey(route) {
            return tabManager.getRouteKey(route)
        },

        clear() {
            tabManager.clear()
        },
    })

    Object.defineProperty(facade, 'VTK', {
        enumerable: true,
        configurable: false,
        get: () => tabManager.options.VTK,
    })

    Object.defineProperty(facade, 'cacheList', {
        enumerable: true,
        configurable: false,
        get: () => [...tabManager.state.cacheList],
    })

    Object.defineProperty(facade, 'tabs', {
        enumerable: true,
        configurable: false,
        get: () => [...tabManager.tabs],
    })

    Vue.$aliveTab = Vue.prototype.$aliveTab = facade
}

export default install
export { facade as aliveTab }